import Register from '../../../../../components/Register/Register';

export default Register;
